.root {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}

.textContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
